import api from '@/services/api';
import type { PaginatedResponse } from '@/types/api';
import type {
  AdminUser,
  RoleOption,
  CreateUserRequest,
  UpdateUserRequest,
  ResetPasswordRequest,
} from '@/types/user';

const BASE_PATH = '/admin/users';

/**
 * Admin user management API service.
 */
export const userAdminService = {
  async getUsers(page = 1, limit = 20): Promise<PaginatedResponse<AdminUser>> {
    const { data } = await api.get<PaginatedResponse<AdminUser>>(BASE_PATH, {
      params: { page, limit },
    });
    return data;
  },

  async getUser(id: string): Promise<AdminUser> {
    const { data } = await api.get<AdminUser>(`${BASE_PATH}/${id}`);
    return data;
  },

  async getRoles(): Promise<RoleOption[]> {
    const { data } = await api.get<RoleOption[]>(`${BASE_PATH}/roles`);
    return data;
  },

  async createUser(payload: CreateUserRequest): Promise<AdminUser> {
    const { data } = await api.post<AdminUser>(BASE_PATH, payload);
    return data;
  },

  async updateUser(id: string, payload: UpdateUserRequest): Promise<AdminUser> {
    const { data } = await api.put<AdminUser>(`${BASE_PATH}/${id}`, payload);
    return data;
  },

  async activateUser(id: string): Promise<AdminUser> {
    const { data } = await api.put<AdminUser>(`${BASE_PATH}/${id}/activate`);
    return data;
  },

  async deactivateUser(id: string): Promise<AdminUser> {
    const { data } = await api.put<AdminUser>(`${BASE_PATH}/${id}/deactivate`);
    return data;
  },

  async resetPassword(id: string, payload: ResetPasswordRequest): Promise<AdminUser> {
    const { data } = await api.put<AdminUser>(`${BASE_PATH}/${id}/reset-password`, payload);
    return data;
  },
};
